export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-slate-800/80 px-6 py-8 text-center text-slate-500">
      <p className="text-sm">
        © {new Date().getFullYear()} Siva Sai Kumar. Built with React and Tailwind CSS.
      </p>
      <p className="mt-2 text-xs uppercase tracking-[0.28em] text-slate-600">
        <a
          href="https://github.com/shivafobl"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-sky-300"
        >
          github.com/shivafobl
        </a>
      </p>
    </footer>
  );
}
